const SHOW_INFO = {
    LOG: false,
    DATA: false,
    ERROR: false,
    WARN: false,
}

const SHOW_REQUEST_INFO = {
    REQUEST: false,
    HEADER: false,
    BODY: false,
    RESPONSE: false,
}

const ROUTE_INDEX = '/'

const APP_VERSION = {
    NAME: '1.2.0',
    RELEASE_DATE: '04/02/2025',
}

const FLAG_TESTE = 'N'

const ISDEV = process.env.NODE_ENV === 'development'

const config = {
    SHOW_INFO, SHOW_REQUEST_INFO, APP_VERSION, ROUTE_INDEX, FLAG_TESTE, ISDEV
}

export default config
export { SHOW_INFO, SHOW_REQUEST_INFO, APP_VERSION, ROUTE_INDEX, FLAG_TESTE, ISDEV }